module.exports = __webpack_public_path__ + "static/media/q6.7ec377c9.png";